import Decimal from "decimal.js";
import UnitPrice from "./unit-price";
import { EstimateItemId } from "./estimate-item";
import PurchaseOrderItems from "./purchase-order-items";

type PurchaseOrderItemId = string;

/**
 * 発注項目
 */
export default class PurchaseOrderItem {
  private readonly originalUnitPrice: UnitPrice;
  private readonly originalUnitLoss: UnitPrice;

  public constructor(
    public id: PurchaseOrderItemId = "",
    public estimateItemId: EstimateItemId = "",
    public unitName: string = "",
    public unitType: string = "",
    unitPrice: UnitPrice = new UnitPrice(0),
    unitLoss: UnitPrice = new UnitPrice(0),
    public amount: Decimal.Value = 0,
    public memo: string = "",
    public items: PurchaseOrderItems = new PurchaseOrderItems()
  ) {
    this.originalUnitPrice = unitPrice;
    this.originalUnitLoss = unitLoss;
  }

  public get unitPrice(): UnitPrice {
    if (this.items.isEmpty()) {
      return this.originalUnitPrice;
    }
    if (this.amount <= 0) {
      return new UnitPrice(0);
    }
    return new UnitPrice(this.price.div(this.amount));
  }

  public get price(): Decimal {
    if (this.items.isEmpty()) {
      return new Decimal(this.unitPrice.toNumber()).times(this.amount);
    }
    return new Decimal(this.items.totalPrice.toNumber());
  }

  public get unitLoss(): UnitPrice {
    if (this.items.isEmpty()) {
      return this.originalUnitLoss;
    }
    if (this.amount <= 0) {
      return new UnitPrice(0);
    }
    return new UnitPrice(new Decimal(this.loss).div(this.amount));
  }

  public get loss(): Decimal {
    if (this.items.isEmpty()) {
      return new Decimal(this.unitLoss.toNumber()).times(this.amount);
    }
    return new Decimal(this.items.totalLoss.toNumber());
  }

  public toJSON(): any {
    return {
      id: this.id,
      estimateItemId: this.estimateItemId,
      amount: this.amount,
      unitName: this.unitName,
      unitType: this.unitType,
      unitPrice: this.unitPrice.toNumber(),
      totalPrice: this.price.toNumber(),
      unitLoss: this.unitLoss.toNumber(),
      loss: this.loss.toNumber(),
      memo: this.memo,
      items: this.items.toJSON()
    };
  }
}
